import { render, staticRenderFns } from "./mark-num.vue?vue&type=template&id=16ebae66&scoped=true&"
import script from "./mark-num.vue?vue&type=script&lang=js&"
export * from "./mark-num.vue?vue&type=script&lang=js&"
import style0 from "./mark-num.vue?vue&type=style&index=0&id=16ebae66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ebae66",
  null
  
)

export default component.exports